import { Link } from "react-router-dom";

function NavBar({
  nickname,
  name,
}: {
  nickname?: string | null;
  name?: string | null;
}) {
  return (
    <div className="main_content">
      <div className="header">
        <ul>
          {/* <li>
            <img src="/images/Bell Icon.png" alt="" />
          </li> */}
          <li>
            <Link to="/settings">
              <i className="fas fa-cog" style={{ marginRight: "-20px" }}></i>
            </Link>
          </li>
          <li>
            <div className="profilePic">
              <Link to={`/profile/${nickname}`}>
                <img src="/images/Profile_Pic.png" alt="" />
                {nickname} ({name})
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBar;
